export const commonES = require("./commonES.json");
export const pagesES = require("./pagesES.json");
export const messagesES = require("./messagesES.json");
